// ABOUTME: NavBar cart button showing the active cart's item count as a badge.
// ABOUTME: Opens the cart drawer on click; renders nothing when the cart feature is disabled.

import { Badge, IconButton, ShoppingCartOutlinedIcon, Tooltip } from '@ds/coolshop';
import { useIntl } from 'react-intl';

import { useCartContext } from './CartContext';

export function CartNavButton() {
    const { formatMessage } = useIntl();
    const cart = useCartContext();

    if (!cart || !cart.enabled) {
        return null;
    }

    const title = formatMessage({ id: 'cpq.cart.title', defaultMessage: 'Cart' });

    // Built as the notification bell next to it: tooltip, white round button, outlined icon,
    // capped badge.
    return (
        <Tooltip title={title} placement="bottom">
            {/* White round button, as in the app bar visuals. */}
            <IconButton
                variant="contained"
                color="primary"
                invertedColor
                aria-label={title}
                // Toggles: with the cart open, the same button closes it.
                onClick={cart.isDrawerOpen ? cart.closeDrawer : cart.openDrawer}
                aria-expanded={cart.isDrawerOpen}
            >
                <Badge badgeContent={cart.itemCount} max={99} color="secondary">
                    <ShoppingCartOutlinedIcon />
                </Badge>
            </IconButton>
        </Tooltip>
    );
}
